import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import Layout from "./common/components/Layout";

// Componentes Principales
import Login from "./common/components/auth/Login";
import Register from "./common/components/auth/Register";
import Dashboard from "./common/components/dashboard/Dashboard";
import PanelHerramientasAdmin from "./common/components/admin/PanelHerramientasAdmin";

// Módulos
import EvaluacionesDashboard from "./modules/desarrollo-personal/evaluation/EvaluacionesDashboard";
import Evaluation from "./modules/desarrollo-personal/evaluation/Evaluation";
import CierreMes from "./modules/operaciones/cierreMes/CierreMes";
import Capacitaciones from "./modules/desarrollo-personal/capacitaciones/Capacitaciones";
import SeguridadSst from "./modules/operaciones/seguridadSst/SeguridadSst";
import CertificadosModule from "./modules/desarrollo-personal/certificados/CertificadosModule";
import DocumentosLegales from "./modules/gestionHumana/documentosLegales/DocumentosLegales";
import Preoperacional from "./modules/operaciones/preoperacional/Preoperacional";
import ModuloPersonalMain from "./modules/gestionHumana/permisos/ModuloPersonalMain";
import GestionHumana from "./modules/gestionHumana/GestionHumana";
import InventariosMenu from './modules/operaciones/inventarios/InventariosMenu';
import SupervisionPOS from "./modules/operaciones/puntodeventapos/PuntoDeVentaPos";
import NominaPagos from "./modules/gestionHumana/nominaPagos/NominaPagos"; 
import ReportesBI from "./modules/operaciones/reportes/ReportesBI";
import AuditoriaTesoreria from "./modules/operaciones/auditoriaTesoreria/AuditoriaTesoreria";
import GestorHorarios from "./modules/gestionHumana/Horarios/GestorHorarios";
import ControlAccesos from "./modules/gestionHumana/controlAccesos/ControlAccesos"; 
import GestionFormularios from "./common/components/formularios/GestionFormularios";

function App() {
  const { usuario, cargandoSesion, iniciarSesion, cerrarSesion } = useContext(AuthContext);

  const [vistaActual, setVistaActual] = useState("dashboard");
  const [moduloSeleccionado, setModuloSeleccionado] = useState(null);
  const [subVistaEvaluacion, setSubVistaEvaluacion] = useState("tabla");

  useEffect(() => {
    const manejarRetroceso = (e) => {
      const estado = e.state;
      if (!estado) {
        setVistaActual("dashboard");
        setModuloSeleccionado(null);
        return;
      }

      setVistaActual(estado.pantalla || "dashboard");
      setModuloSeleccionado(estado.id || null);
      if (estado.pantalla === "dashboard" || estado.pantalla === "modulo") setSubVistaEvaluacion("tabla");
      if (estado.pantalla === "formulario") setSubVistaEvaluacion("formulario");
    };

    window.addEventListener("popstate", manejarRetroceso);
    return () => window.removeEventListener("popstate", manejarRetroceso);
  }, []);

  const navegarA = (pantalla, id = null) => {
    try {
      window.history.pushState({ pantalla, id }, "");
    } catch (e) {}
    setVistaActual(pantalla);
    setModuloSeleccionado(id);
    if (pantalla === "modulo") setSubVistaEvaluacion("tabla");
    if (pantalla === "formulario") setSubVistaEvaluacion("formulario");
  };

  const volverNativo = () => {
    setModuloSeleccionado(null);
    setVistaActual("dashboard");
    try {
      window.history.pushState({ pantalla: "dashboard", id: null }, "");
    } catch (e) {}
  };

  const handleLogout = () => {
    cerrarSesion();
    navegarA("login");
  };

  const renderizarContenidoModulo = () => {
    const mod = (moduloSeleccionado || "").toLowerCase();

    if (mod === "evaluacion") {
      return subVistaEvaluacion === "formulario" 
        ? <Evaluation usuario={usuario} onBackToModules={volverNativo} onComplete={volverNativo} />
        : <div className="glass-panel rounded-3xl p-4 sm:p-6 max-h-[92vh] overflow-y-auto animate-smooth-modal"><EvaluacionesDashboard usuario={usuario} onBackToMenu={volverNativo} onStartNewEvaluation={() => navegarA("formulario", moduloSeleccionado)} /></div>;
    }

    if (mod === "preoperacional") return <Preoperacional usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "cierre_mes" || mod === "cierre mes") return <CierreMes usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "capacitaciones") return <Capacitaciones usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "sst" || mod === "seguridad sst") return <SeguridadSst usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "documentos_legales") return <DocumentosLegales usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "certificados_generales" || mod === "certificados generales") return <CertificadosModule onBack={volverNativo} />;
    if (mod === "gestion_humana" || mod === "gestion humana") return <GestionHumana usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "permisos") return <ModuloPersonalMain usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "pos" || mod === "punto de venta pos") return <SupervisionPOS usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "inventario" || mod === "inventario y stock") return <InventariosMenu usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "control accesos") return <ControlAccesos usuario={usuario} onBackToMenu={volverNativo} />;    
    if (mod === "nomina" || mod === "nomina y pagos") return <NominaPagos usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "reportes") return <ReportesBI usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "auditoria_tesoreria") return <AuditoriaTesoreria usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "gestion_horarios") return <GestorHorarios usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "recursos" || mod === "control accesos") return <ControlAccesos usuario={usuario} onBackToMenu={volverNativo} />;
    if (mod === "formularios") return <GestionFormularios usuario={usuario} onBackToMenu={volverNativo} />;

    return (
      <div className="bento-card p-8 text-center w-full max-w-lg mx-auto animate-smooth-modal">
        <span className="text-6xl block mb-4 animate-bounce drop-shadow-lg">🚧</span>
        <h2 className="text-2xl font-black text-slate-800 mb-2 capitalize tracking-tight">{moduloSeleccionado?.replace(/_/g, " ")}</h2>
        <p className="text-slate-600 text-sm mb-8 font-bold">Este módulo se encuentra actualmente en desarrollo y pronto estará disponible.</p>
        <button onClick={volverNativo} className="btn-interactive bg-blue-600 hover:bg-blue-700 text-white font-black uppercase tracking-wider text-xs py-3.5 px-8 rounded-xl shadow-lg shadow-blue-500/30">
          Volver al Menú
        </button>
      </div>
    );
  };

  if (cargandoSesion) return null;

  if (!usuario) {
    if (vistaActual === "register") {
      return <Register onBack={() => navegarA("login")} />;
    }
    return (
      <Login
        onLoginSuccess={(user) => {
          iniciarSesion(user);
          navegarA("dashboard");
        }}
        onGoToRegister={() => navegarA("register")}
      />
    );
  }

  if (vistaActual === "estructura") {
    return (
      <Layout>
        <PanelHerramientasAdmin onBack={volverNativo} />
      </Layout>
    );
  }

  if ((vistaActual === "dashboard" || vistaActual === "login") && !moduloSeleccionado) {
    return (
      <Layout>
        <Dashboard
          user={{ ...usuario, modulosPermitidos: usuario?.modules || [] }}
          onLogout={handleLogout}
          onSelectModule={(mod) => navegarA("modulo", mod)}
          onOpenEstructura={() => navegarA("estructura")}
        />
      </Layout>
    );
  }

  return (
    <Layout>
      {renderizarContenidoModulo()}
    </Layout>
  );
}

export default App;